import { Link } from 'react-router-dom';

export default function PharmaceuticalWholesale() {
  const wholesaleCompanies = [
    {
      title: 'メディセオ',
      description: '医薬品・医療機器の総合卸売業者',
      url: 'https://www.mediceo.co.jp/',
      category: '医薬品卸',
      icon: 'ri-medicine-bottle-line',
      color: 'bg-orange-50 text-orange-600',
      features: ['医薬品', '医療機器', '試薬', '診断薬'],
      established: '1927年',
      coverage: '全国展開',
      specialties: ['病院向け卸売', '薬局向け卸売', '医療機器販売', 'DI情報提供']
    },
    {
      title: 'アルフレッサ',
      description: '医薬品・医療機器の卸売業界大手企業',
      url: 'https://www.alfresa.com/',
      category: '医薬品卸',
      icon: 'ri-medicine-bottle-line',
      color: 'bg-blue-50 text-blue-600',
      features: ['医薬品', '医療機器', '試薬', '診断薬'],
      established: '2003年',
      coverage: '全国展開',
      specialties: ['医薬品卸売', '医療機器販売', '在宅医療支援', 'IT・システム開発']
    },
    {
      title: '東邦薬品',
      description: '医薬品・医療機器の専門卸売業者',
      url: 'https://www.tohoyakuhin.co.jp/',
      category: '医薬品卸',
      icon: 'ri-medicine-bottle-line',
      color: 'bg-green-50 text-green-600',
      features: ['医薬品', '医療機器', '試薬', '診断薬'],
      established: '1948年',
      coverage: '全国展開',
      specialties: ['調剤薬局支援', '病院向けサービス', '在宅医療支援', '医療情報提供']
    },
    {
      title: 'スズケン',
      description: '医薬品・医療機器の総合卸売企業',
      url: 'https://www.suzuken.co.jp/',
      category: '医薬品卸',
      icon: 'ri-medicine-bottle-line',
      color: 'bg-purple-50 text-purple-600',
      features: ['医薬品', '医療機器', '試薬', '診断薬'],
      established: '1946年',
      coverage: '全国展開',
      specialties: ['医薬品流通', '医療機器販売', 'ヘルスケア事業', '医療IT事業']
    }
  ];

  const serviceCategories = [
    {
      name: '医薬品卸売',
      description: '処方薬・OTC医薬品の卸売業務',
      icon: 'ri-capsule-line',
      items: ['処方薬', 'OTC医薬品', 'ジェネリック医薬品', '希少疾病用医薬品', 'ワクチン', '血液製剤']
    },
    {
      name: '医療機器販売',
      description: '診断・治療・検査機器の販売',
      icon: 'ri-heart-pulse-line',
      items: ['診断機器', '治療機器', '検査機器', '画像診断装置', '手術用機器', '在宅医療機器']
    },
    {
      name: '情報提供サービス',
      description: 'DI情報・学術情報の提供',
      icon: 'ri-information-line',
      items: ['薬剤情報', '副作用情報', '相互作用情報', '適正使用情報', '安全性情報', '学術資料']
    },
    {
      name: '物流・配送',
      description: '効率的な医薬品物流システム',
      icon: 'ri-truck-line',
      items: ['定期配送', '緊急配送', '冷蔵配送', '温度管理', '在庫管理', 'トレーサビリティ']
    }
  ];

  const industryFeatures = [
    {
      title: '品質保証',
      description: '医薬品の品質管理と安全性確保',
      icon: 'ri-shield-check-line',
      points: [
        'GDP（Good Distribution Practice）の遵守',
        '温度管理・湿度管理の徹底',
        '偽造医薬品対策の実施',
        '品質管理システムの構築'
      ]
    },
    {
      title: '安定供給',
      description: '医療現場への確実な医薬品供給',
      icon: 'ri-refresh-line',
      points: [
        '全国ネットワークによる配送体制',
        '災害時の供給継続体制',
        '需要予測による在庫最適化',
        '緊急時対応システム'
      ]
    },
    {
      title: '情報提供',
      description: '医療従事者への情報サポート',
      icon: 'ri-file-text-line',
      points: [
        'DI（Drug Information）サービス',
        '学術情報の提供',
        '安全性情報の迅速な伝達',
        '適正使用推進活動'
      ]
    },
    {
      title: 'デジタル化',
      description: 'IT技術による業務効率化',
      icon: 'ri-computer-line',
      points: [
        '電子商取引システム',
        '在庫管理システム',
        'トレーサビリティシステム',
        'データ分析・活用'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-orange-50 to-red-50 py-16">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/de81afe036bc4c7dce14f2c9e3aa9a16.jpg"
            alt="医薬品卸サイト"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-orange-600">医薬品卸</span>サイト
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            医薬品・医療機器の専門卸売業者情報
          </p>
        </div>
      </section>

      {/* Wholesale Companies */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">主要医薬品卸売企業</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {wholesaleCompanies.map((company, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100">
                <div className="flex items-start justify-between mb-6">
                  <div className={`w-16 h-16 rounded-xl ${company.color} flex items-center justify-center`}>
                    <i className={`${company.icon} text-2xl`}></i>
                  </div>
                  <div className="text-right">
                    <span className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full">{company.category}</span>
                  </div>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{company.title}</h3>
                <p className="text-gray-600 mb-4">{company.description}</p>
                
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div>
                    <p className="text-sm font-medium text-gray-700">設立年</p>
                    <p className="text-gray-600">{company.established}</p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-700">展開エリア</p>
                    <p className="text-gray-600">{company.coverage}</p>
                  </div>
                </div>

                <div className="mb-6">
                  <p className="text-sm font-medium text-gray-700 mb-2">取扱商品:</p>
                  <div className="flex flex-wrap gap-1">
                    {company.features.map((feature, featureIndex) => (
                      <span key={featureIndex} className="bg-gray-50 text-gray-600 text-xs px-2 py-1 rounded">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="mb-6">
                  <p className="text-sm font-medium text-gray-700 mb-2">主要サービス:</p>
                  <ul className="space-y-1">
                    {company.specialties.map((specialty, specialtyIndex) => (
                      <li key={specialtyIndex} className="text-sm text-gray-600 flex items-center">
                        <i className="ri-check-line text-orange-600 mr-2"></i>
                        {specialty}
                      </li>
                    ))}
                  </ul>
                </div>

                <a
                  href={company.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-orange-600 font-medium hover:text-orange-700 cursor-pointer"
                >
                  公式サイトを見る →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Categories */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">サービスカテゴリー</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {serviceCategories.map((category, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
                <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{category.name}</h3>
                <p className="text-gray-600 mb-4 text-sm">{category.description}</p>
                <ul className="space-y-1">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-sm text-gray-500 flex items-center">
                      <i className="ri-check-line text-orange-600 mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Features */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">医薬品卸業界の特徴</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {industryFeatures.map((feature, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 mb-4 text-sm">{feature.description}</p>
                <ul className="space-y-2">
                  {feature.points.map((point, pointIndex) => (
                    <li key={pointIndex} className="text-sm text-gray-600 flex items-start">
                      <i className="ri-arrow-right-s-line text-blue-600 mr-1 mt-0.5"></i>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Important Notice */}
      <section className="py-16 bg-yellow-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-8 border-l-4 border-yellow-400">
            <div className="flex items-start">
              <div className="w-8 h-8 bg-yellow-100 text-yellow-600 rounded-full flex items-center justify-center mr-4 mt-1">
                <i className="ri-alert-line"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">医薬品卸業界について</h3>
                <div className="space-y-3 text-gray-700">
                  <p>
                    <strong>医薬品卸売業の役割：</strong>
                    医薬品卸売業者は、製薬企業から医薬品を仕入れ、病院・診療所・薬局等の医療機関に安定的に供給する重要な役割を担っています。
                  </p>
                  <p>
                    <strong>品質管理と安全性：</strong>
                    医薬品の品質維持、適切な保管・輸送、偽造医薬品対策など、医薬品の安全性確保に重要な責任を負っています。
                  </p>
                  <p>
                    <strong>情報提供機能：</strong>
                    医薬品に関する情報提供、安全性情報の伝達、適正使用の推進など、医療の質向上に貢献しています。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">医薬品卸企業</h3>
              <ul className="space-y-2 text-gray-400">
                <li><a href="https://www.mediceo.co.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">メディセオ</a></li>
                <li><a href="https://www.alfresa.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">アルフレッサ</a></li>
                <li><a href="https://www.tohoyakuhin.co.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">東邦薬品</a></li>
                <li><a href="https://www.suzuken.co.jp/" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer">スズケン</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/pharmacist-resources" className="hover:text-white cursor-pointer">専門リソース</Link></li>
                <li><Link to="/package-insert-search" className="hover:text-white cursor-pointer">添付文書検索</Link></li>
                <li><Link to="/drug-price-search" className="hover:text-white cursor-pointer">薬価サーチ</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/medical-purchase" className="hover:text-white cursor-pointer">医療・介護用品サイト</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}